import { MDBCol, MDBContainer, MDBRow } from "mdbreact";
import React from "react";

const Spinner = () => {
  return (
    <React.Fragment>
      <MDBContainer>
        <MDBRow>
          <MDBCol md="4"></MDBCol>
          <MDBCol md="4" className="text-center">
            <br />
            <img
              src={process.env.PUBLIC_URL + "/loading.gif"}
              style={{ width: "300px", textAlign: "center" }}
              alt="loading"
            />
            <br />
          </MDBCol>
          <MDBCol md="4"></MDBCol>
        </MDBRow>
      </MDBContainer>
    </React.Fragment>
  );
};

export default Spinner;
